import ButtonLink from '../../../../common/components/Button/ButtonLink.js'
import {showConfirmMessageModal} from '../../../../common/components/Modal/ConfirmMessageModal.js'
import {
  Count,
  Plural,
  PluralBlock,
} from '../../../../common/components/Plural.js'
import {shippingInfoSelector} from '../../../../data/orders.js'
import {presetSelector} from '../../../../data/presets.js'
import {getState, useSelector} from '../../../../store.js'
import {showEditPresetModal} from '../../../LabelConfig/Modals/EditPresetModal/index.js'
import ListItem from './Fields/ListItem.js'

function showPresetAppliedSummary(orderNumber, presetIDs) {
  const presets = presetIDs
    .map((presetID) => presetSelector(getState(), {presetID}))
    .filter((v) => v)

  showConfirmMessageModal({
    title: 'History of Presets Applied',
    Message: () => (
      <div>
        <p className="fs-01 lh-md margin-bottom-0">
          <strong>
            Presets were applied to Order {orderNumber} in the following
            sequence:
          </strong>
        </p>
        <ul className="list list--square">
          {presets.map((preset, index) => (
            <li
              className="list__item fs-00 lh-md margin-bottom-0 margin-top-10"
              key={index}
            >
              <ButtonLink
                className="no-underline border-underline"
                onClick={() => showEditPresetModal({presetID: preset.id})}
              >
                {preset.name}
              </ButtonLink>
            </li>
          ))}
        </ul>
      </div>
    ),
    hideConfirm: true,
    cancelText: 'Close',
  })
}

export default function PresetsAppliedSummary({orderNumber}) {
  const {presets} =
    useSelector((state) => shippingInfoSelector(state, {orderNumber})) || {}

  if (!presets?.length) {
    return null
  }

  return (
    <ListItem className="divider--top">
      <ButtonLink
        onClick={() => showPresetAppliedSummary(orderNumber, presets)}
      >
        <PluralBlock array={presets}>
          <Count /> <Plural word="Preset" /> Applied
        </PluralBlock>
      </ButtonLink>
    </ListItem>
  )
}
